import React from 'react';
import { styled } from 'styled-components';
import colors from '../../../styles/colors';
import { getWeekdays, type CalendarDay } from '../../../helpers/calendarHelper';
import { getLocale } from '../../../helpers/localeHelper';

interface WeekdaysProps {
  calendarDays: CalendarDay[];
}

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  place-items: center;
  gap: 4px;
  padding-bottom: 10px;
  color: ${colors.text.default};
  margin: 0;
`;

const StyledWeekDay = styled.abbr`
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
  user-select: none;
  text-decoration: none;
`;

const Weekdays: React.FC<WeekdaysProps> = ({ calendarDays }) => {
  const locale = getLocale();
  const days = getWeekdays(calendarDays, locale);
  return (
    <StyledContainer aria-hidden="true">
      {days.map((day) => (
        <StyledWeekDay key={day.name} title={day.title}>
          {day.name}
        </StyledWeekDay>
      ))}
    </StyledContainer>
  );
};

export default Weekdays;
